module.exports = __webpack_public_path__ + "static/icon-acoustic-guitar-a9ab015e6fcc3b3cea5b5ecd15f608df.svg";